module.exports = __webpack_public_path__ + "img/banana.1b84ec9f.svg";